<div class="esf-form-item__field-wrapper" *ngIf="control">
  <input class="esf-form-item__field"
         type="text"
         [formControl]="formControl"
         [id]="id"
         [placeholder]="placeholder"
         autocomplete="off"
         #searchBox
         (focus)="isBlurred = false"
         (input)="searchInput.next($event)"
         (keydown.enter)="enterKeyDown($event)">
  <span class="esf-form-item__icon">
    <svg class="esf-icon" width="16" height="16">
      <use xlink:href="#esf-icon-search"></use>
    </svg>
  </span>
</div>

<div class="esf-form-item__field-wrapper" *ngIf="!control">
  <input class="esf-form-item__field"
         type="text"
         [id]="id"
         [placeholder]="placeholder"
         (input)="searchInput.next($event)"
         list="autocompleteOff"
         autocomplete="off">
  <span class="esf-form-item__icon">
    <svg class="esf-icon" width="16" height="16">
      <use xlink:href="#esf-icon-search"></use>
    </svg>
  </span>
</div>